/* Component Dependencies */
var template = require('templates/optionWidget.hbs');
var templateconfirmPath = require('templates/optionWidget-confirmationPath.hbs');
var templateconfirmation = require('templates/optionWidget-confirmation.hbs');
var templateModifyPath = require('templates/optionWidget-modifyPath.hbs');
var templateAssociate = require('templates/optionWidget-associate.hbs');
var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');
var Popup = require('libs/popup');
var makeSendToLink = require('utils/makeSendtoLink');
var $ = require('jquery');
var Constants = require('libs/constants');
var Config = require('libs/takeoverConfig');

PubSub.register(AriesComponent.extend({
  type: 'optionWidget',
  template: {
    'optionWidget': template,
    'optionWidget-confirmationPath':templateconfirmPath,
    'optionWidget-confirmation':templateconfirmation,
    'optionWidget-modifyPath' : templateModifyPath,
    'optionWidget-associate' : templateAssociate
  },
  subscribe: {
    'OPTION_WIDGET_REFRESH': 'refresh'
  },
  events: {
    'click .js-more-options': 'showHideOptions',
    'click .js-options' : 'optionWidgetClickHandler',
    'click .js-reservation-history': 'toggleReservationHistoryFlyout'
  },
  bindEvents: function() {
    var _self = this,
    showCancelAllRoomsPopUp = this.$el.data('showCancelRoomsPopUp'),
    cancelAllRoomsCTA = this.$el.find('.js-cancel-room-link');
    makeSendToLink.initialize(this.$el.find("a.sendto-link"));

    if (this.$el.find('.js-res-popover').length) {
      var smsPopup = new Popup({
        selector: '[data-component-id="' + this.$el.data('component-id') + '"] .js-res-popover',
        sourceBlock: '.modal-content',
        alternateCloseMarkup: true
      });
      smsPopup.register();
    }
    if (this.$el.find('.js-email-popover').length) {
      var emailPopup = new Popup({
        selector: '.js-email-popover',
        sourceBlock: '.modal-content',
        alternateCloseMarkup: true
      });
      emailPopup.register();
    }
    if(this.$el.find('.force-sell-widget').length) {
      _self.initForceSellPopup();
    }
    if (this.$el.find('.js-send-to-concur-popover').length) {
      var sendToConcurPopup = new Popup({
            selector: '.js-send-to-concur-popover',
            sourceBlock: '.modal-content',
            alternateCloseMarkup: true
        });
      sendToConcurPopup.register();
    }

    if(this.$el.find('.js-print-popup').length){
      var showPrintPopup = new Popup({
        selector: '.js-print-popup',
        mainClass: 'mfp-modal-print',
        sourceBlock: '.modal-content',
        alternateCloseMarkup: true
      });
      showPrintPopup.register();
    }

    if(cancelAllRoomsCTA.length){
      var popUpConfig = {
        selector: '.js-cancel-room-link',
        sourceBlock: '.modal-content',
        alternateCloseMarkup: true
      };
      if (showCancelAllRoomsPopUp) {
        popUpConfig['url']=cancelAllRoomsCTA.attr('href'),
        popUpConfig['open'] = true;
      }
      var cancelRoomPopup = new Popup(popUpConfig);
      cancelRoomPopup.register();
    }
    
    if (this.$el.hasClass('tile-option-widget-modify-path')) {
      this.$el.on('click', function (e) { _self.onOptionWidgetClick.call(_self, e) });
    }
    this.showReservationHistoryPopup();

    //Bind event on Option widget tile on window resize
    if(this.$el.hasClass('tile-option-widget-confirmation')){
        $(window).on('resize' , function(){
          _self.handleResize();
      });
    }

    if(_self.$el.find('.js-res-flyout-container').length) {
      var multiRoomResHistory = new Popup({
        selector: '.js-res-flyout-container .js-individual-res-room',
        sourceBlock: '.modal-content',
        alternateCloseMarkup: true
      });
      multiRoomResHistory.register();
    }

    _self.$el.find('.js-reservation-history').on('keydown', function(event) {
      if(event.keyCode === 13 || event.keyCode === 32) {
        _self.toggleReservationHistoryFlyout();
      }
    })
  },

  /**
  * This function is used to toggle the Reservation History container in multi-room booking scenario.
  */
  toggleReservationHistoryFlyout: function _toggleReservationHistoryFlyout(){
    this.$el.find('.js-res-flyout-container').toggle();
    this.$el.find('.js-arrow-item').toggleClass('t-icon-arrow-down, t-icon-arrow-up');
  },

  /**
   * This function show/hides the flyouts.
   * @param {Object} event Event is passed
   */
  onOptionWidgetClick: function (event) {
    event.preventDefault();
    var target = $(event.currentTarget),
        widgetLink = target.find('.js-widget-link');
    if(widgetLink.hasClass('email-widget')) {
      target.next().addClass('email-flyout-width');
    }
    else if(widgetLink.hasClass('sms-confo-widget')) {
      target.next().addClass('sms-flyout-width');
    }
    else if(widgetLink.hasClass('book-additional-rooms-widget')) {
      target.next().addClass('book-additional-rooms-flyout-width');
    }
    target.next().toggleClass('is-hidden');
  },

  /**
   * This function show/hides the flyouts.
   * @param {Object} event Event is passed
   */
  optionWidgetClickHandler: function _optionWidgetClickHandler(event) {
    event.preventDefault();
    var target = $(event.currentTarget), targetAction, position = {}, optionWidgetLI = target.parents('li'), _self = this;
    position = {left : (target.offset()).left, top : '100%'};
    targetAction = target.data('action');
    if(target.hasClass('js-is-active')){
      target.removeClass('js-is-active');
      optionWidgetLI.find('.l-em-reset').addClass('is-hidden');
    }else{
      _self.$el.find('.js-options').removeClass('js-is-active');
      target.addClass('js-is-active');
      optionWidgetLI.find('.l-em-reset').addClass('is-hidden');
      if(targetAction === 'js-email-option') {
        optionWidgetLI.find('.tile-email-resend-flyout-confirmation').parents('.l-em-reset').addClass('email-flyout-width').removeClass('is-hidden');
        optionWidgetLI.find('.email-flyout-width').css(position);
      }
      else if(targetAction === 'js-sms-option') {
        optionWidgetLI.find('.tile-sms-resend-notification-confirmation').parents('.l-em-reset').addClass('sms-flyout-width').removeClass('is-hidden');
        optionWidgetLI.find('.sms-flyout-width').css(position);
      }
      else if(targetAction === 'js-book-another-room-option') {
        optionWidgetLI.find('.tile-book-additional-rooms').parents('.l-em-reset').addClass('book-additional-rooms-flyout-width').removeClass('is-hidden');
        if(this.$el.find('.js-send-to-concur').length){
          position.left = position.left - 23;
          optionWidgetLI.find('.book-additional-rooms-flyout-width').css(position);
        }
        else{
          optionWidgetLI.find('.book-additional-rooms-flyout-width').css(position);
        }
      }
    }
  },
  /**
   * Initializes reservation history popup from option widget
   */
  showReservationHistoryPopup: function () {
    var reservationHistoryPopup = new Popup({
      selector: '.reservation-history-widget',
      mainClass: 'm-modal t-modal-med option-widget-res-history-overlay',
      alternateCloseMarkup: true,
      sourceBlock: '.modal-content'
    });
    reservationHistoryPopup.register();
  },
  /**
  * Opens forceSell Popup triggered from forceSell widget from option widget
  */
  initForceSellPopup: function () {
    var widgetforceSellPopup = new Popup({
      selector: '.force-sell-widget',
      mainClass: 'm-modal t-modal-smallMed option-widget-force-sell-overlay',
      sourceBlock: '.modal-content'
    });
    widgetforceSellPopup.register();
  },
  /**
  * Show or hide the Option widget options
  */
  showHideOptions: function(e){
    e.preventDefault();
    var $element = this.$el;
    $element.toggleClass('is-open'); 
    this.mobileTakeover()
  },
  /**
  * Handling window resize event on Option widget tile
  */
  handleResize : function(){
    var width = window.innerWidth,
        viewport = Constants.GLOBAL.TABLET_VIEWPORT + 1;

    if(width>viewport && this.$el.hasClass('is-open')){
      this.showHideOptions();
      this.$el.addClass('is-desktop-open');
    } else if(width<=viewport && this.$el.hasClass('is-desktop-open')){
      this.showHideOptions();
      this.$el.removeClass('is-desktop-open');
    } else {}

    this.mobileTakeover();
  },
  /**
  * Handling mobile takeover on option widget tile
  */
  mobileTakeover : function(){
    var width = window.innerWidth,
    takeover = Constants.GLOBAL.TAKE_OVER_SPEED;
    if(width <= takeover && this.$el.hasClass('is-open')){
      $('body').css(Config.addOverflow);
    } else {
      $('body').css(Config.removeOverflow);
    }
  }
}));
